import { Dictionary } from '../../models/Dictionary';
import { getGroupMarker } from './getGroupMarker';
import { getGroupGuidsOnMap } from './getGroupGuidsOnMap';
import { MapGroupViewModel } from './MapGroupViewModel';

export const getGroupsMarkers = (groupDictionary: Dictionary<MapGroupViewModel>) => {
    const groupMarkers = {};
    if (groupDictionary) {
        const groupGuidsOnMap = getGroupGuidsOnMap(
            Object.values(groupDictionary).map((mapGroup) => mapGroup.group),
            groupDictionary
        );
        groupGuidsOnMap.forEach((guid, i) => {
            groupMarkers[`group${i}`] = getGroupMarker(groupDictionary[guid].group, i, groupDictionary[guid].alarmLevel);
        });
    }
    return groupMarkers;
};
